import { axiosInstance } from '../axios/axiosConfig';

const baseAPIUrl = "LandingPackages";

export async function getPackageDetail(publicId) {
  return await axiosInstance.get(`/${baseAPIUrl}/${publicId}`);
}

export async function getPackages(pagingRequest,) {
  return await axiosInstance.post(`/${baseAPIUrl}/paged`, {
    ...pagingRequest,
  });
}